import { useContext, useEffect, useState } from "react";
import DetailsPanel from "./DetailsPanel";
import WithLoader from "../WithLoader";
import { Button } from "./ActionButtons";
import classNames from "classnames";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import AppContext from "../../contexts/AppContext";
import appFetch from "../../appFetch";
import apiEndpoints from "../../apiEndpoints";
import { buildEditData } from "../../util/generalUtil";
import Spinner from "../../loaders/Spinner";
import { Formik, Form as FormikForm, Field, useFormikContext } from "formik";
import { Dialog } from "@headlessui/react";

const MySwal = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton:
        "text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 bg-primary",
      cancelButton:
        "text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 bg-primary",
    },
    buttonsStyling: false,
  })
);

const excludeHeaders = ["edit_header", "Drillid", "target"];

const CHAR_LIMIT = 50; // change this to 50 or 80 if you prefer

function truncateText(raw, limit = CHAR_LIMIT) {
  if (raw === undefined || raw === null) return "";
  const s = String(raw);
  if (s.length <= limit) return s;
  return s.slice(0, limit) + "...";
}

const CommentModal = ({
  isOpen,
  setIsOpen,
  buttonData,
  updateData,
  processing,
  setProcessing,
}) => {
  let { data, buttonAction, buttonConfig, buttonName } = buttonData;
  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen h-full">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <div className="relative bg-white mx-auto my-10 rounded-md">
          <div className="p-6 pt-14">
            <button
              className="absolute right-4 top-4"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9651 10.4985L20.4829 2.99719C20.8121 2.66793 20.997 2.22136 20.997 1.75571C20.997 1.29007 20.8121 0.843497 20.4829 0.514237C20.1536 0.184977 19.7071 0 19.2416 0C18.776 0 18.3295 0.184977 18.0003 0.514237L10.5 8.03304L2.99975 0.514237C2.67053 0.184977 2.22403 -3.46932e-09 1.75845 0C1.29287 3.46932e-09 0.846361 0.184977 0.517147 0.514237C0.187934 0.843497 0.00298367 1.29007 0.00298367 1.75571C0.00298366 2.22136 0.187934 2.66793 0.517147 2.99719L8.03488 10.4985L0.517147 17.9998C0.353281 18.1624 0.223217 18.3558 0.134458 18.5688C0.0456982 18.7819 0 19.0105 0 19.2413C0 19.4721 0.0456982 19.7007 0.134458 19.9138C0.223217 20.1268 0.353281 20.3202 0.517147 20.4828C0.679675 20.6467 0.87304 20.7768 1.08609 20.8655C1.29914 20.9543 1.52765 21 1.75845 21C1.98925 21 2.21776 20.9543 2.43081 20.8655C2.64386 20.7768 2.83722 20.6467 2.99975 20.4828L10.5 12.964L18.0003 20.4828C18.1628 20.6467 18.3561 20.7768 18.5692 20.8655C18.7822 20.9543 19.0108 21 19.2416 21C19.4723 21 19.7009 20.9543 19.9139 20.8655C20.127 20.7768 20.3203 20.6467 20.4829 20.4828C20.6467 20.3202 20.7768 20.1268 20.8655 19.9138C20.9543 19.7007 21 19.4721 21 19.2413C21 19.0105 20.9543 18.7819 20.8655 18.5688C20.7768 18.3558 20.6467 18.1624 20.4829 17.9998L12.9651 10.4985Z"
                  fill="#747474"
                />
              </svg>
            </button>
            <div className="">
              <Formik
                initialValues={{ APPROVAL_MEMO: "" }}
                onSubmit={async (values, { resetForm }) => {
                  let newData = { ...data };
                  newData["_HEADER"] = { ...newData["_HEADER"], ...values };
                  setProcessing(true);
                  updateData(newData, buttonConfig);
                }}
              >
                <FormikForm className="grid">
                  <Field
                    as="textarea"
                    rows={6}
                    cols={50}
                    name="APPROVAL_MEMO"
                    autoComplete="off"
                    placeholder="add comment"
                    className="pl-3 placeholder-custom-gray-100 placeholder-opacity-40 appearance-none relative block w-full px-3 py-2 border border-custom-gray-300 text-gray-500 rounded-md focus:outline-none sm:text-sm"
                  />
                  <button className="mt-3 bg-primary text-white py-2 rounded-md inline-block self-end inline-flex justify-center">
                    {processing ? (
                      <Spinner width={20} height={20} fill="#f7f7f7" />
                    ) : (
                      buttonAction
                    )}
                  </button>
                </FormikForm>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const TableHeader = ({ headers }) => (
  <thead className="bg-gray-50 sticky top-0 z-10">
    <tr>
      {headers?.map((header) => (
        <th
          key={header}
          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-auto"
        >
          {header}
        </th>
      ))}
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-12 sticky right-0 bg-gray-50">
        <span className="sr-only">Select</span>
      </th>
    </tr>
  </thead>
);

const ExpenseRow = ({
  expense,
  headers,
  isSelected,
  isCurrent,
  onToggle,
  onRowClick,
}) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onToggle(expense.Drillid);
  };

  return (
    <tr
      className={classNames(
        "bg-white border-b border-gray-200 hover:bg-gray-50 cursor-pointer",
        {
          "!bg-gray-50": isCurrent,
          "!cursor-not-allowed opacity-50": isSelected,
        }
      )}
      onClick={() => onRowClick(expense)}
    >
      {headers?.map((header) => {
        const rawValue = expense[header];
        const value =
          rawValue === undefined || rawValue === null ? "" : rawValue;

        // Amount column uses HTML -> don't mutate it
        if (header === "Amount") {
          return (
            <td key={header} className="px-6 py-4 whitespace-nowrap w-auto">
              <span
                className="text-sm font-medium text-gray-900"
                dangerouslySetInnerHTML={{ __html: value }}
              />
            </td>
          );
        }

        // For everything else: compute truncated display and keep full text in title
        const stringValue =
          typeof value === "string" ? value : JSON.stringify(value);
        const shouldTruncate = stringValue.length > CHAR_LIMIT;
        const displayValue = shouldTruncate
          ? truncateText(stringValue, CHAR_LIMIT)
          : stringValue;

        // Add CSS truncate classes to help with long unbroken words
        const cellClasses =
          "text-sm text-gray-900 block overflow-hidden break-words";

        if (header === "Location") {
          return (
            <td
              key={header}
              className="px-6 py-4 whitespace-nowrap w-auto"
              title={stringValue}
            >
              <div className={cellClasses}>{displayValue}</div>
            </td>
          );
        }

        return (
          <td
            key={header}
            className="px-6 py-4 whitespace-nowrap w-auto"
            title={stringValue}
          >
            <span className={cellClasses}>{displayValue}</span>
          </td>
        );
      })}

      <td
        className={classNames(
          "whitespace-nowrap w-12 sticky right-0 bg-white hover:bg-gray-50",
          { "!bg-gray-50": isCurrent }
        )}
      >
        <div className="pl-[.5rem]">
          <label
            htmlFor={expense.Drillid}
            className="mb-[0.125rem] mr-[0.25rem] block min-h-[1.5rem] pl-[1.5rem]"
            onClick={(e) => e.stopPropagation()}
          >
            <input
              disabled={isCurrent}
              id={expense.Drillid}
              type="checkbox"
              onChange={handleCheckboxClick}
              checked={isSelected}
              className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_var(--primary)] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_var(--primary)]"
            />
          </label>
        </div>
      </td>
    </tr>
  );
};

const PendingEmailList = ({ options: optionsItems = [], name, setLoading }) => {
  const [options, setOptions] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [buttonData, updateButtonData] = useState(null);
  const [processing, setProcessing] = useState(false);

  const {
    context: { menuId },
  } = useContext(AppContext);

  const [selectedExpenses, setSelectedExpenses] = useState(new Set());
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(true);

  useEffect(() => {
    setSelectedExpenses(new Set()); // reset selection when page changes
  }, [menuId]);

  useEffect(() => {
    if (menuId) {
      const initialOptions = optionsItems ?? [];
      console.log("the initial options", initialOptions);
      setOptions(initialOptions);

      const groups = initialOptions[0]?.groups ?? [];
      setExpenses(groups);
      setButtons(initialOptions[0]?.multibutton ?? []);

      const hdrs =
        groups.length > 0
          ? Object.keys(groups[0]).filter(
              (header) => !excludeHeaders.includes(header)
            )
          : [];
      setHeaders(hdrs);
    }
  }, [menuId, optionsItems]);

  const toggleExpense = (expenseId) => {
    setSelectedExpenses((prev) => {
      const newSelected = new Set(prev);
      newSelected.has(expenseId)
        ? newSelected.delete(expenseId)
        : newSelected.add(expenseId);
      return newSelected;
    });
  };

  const selectAll = () =>
    setSelectedExpenses(
      new Set(
        expenses
          .filter((x) => selectedExpense?.Drillid !== x.Drillid)
          .map((e) => e.Drillid)
      )
    );

  const deselectAll = () => setSelectedExpenses(new Set());

  const handleRowClick = (expense) => {
    setSelectedExpense(expense);
  };

  const handleToggleFullScreen = () => setIsFullScreen((v) => !v);

  const handleCloseDetails = (groups) => {
    console.log("the groups of expenses", groups);
    setSelectedExpense(null);
    if (groups) setExpenses(groups);
  };

  const handleButtonClick = (buttonConfig) => {
    const editHeaders = expenses
      .filter(({ Drillid }) => selectedExpenses.has(Drillid))
      .map((x) =>
        typeof x.edit_header === "string"
          ? JSON.parse(x.edit_header)
          : x.edit_header
      );

    const postData = {};
    editHeaders.forEach((x) => buildEditData(postData, x));

    updateButtonData({
      data: postData,
      buttonAction: buttonConfig?.action_type ?? "",
      buttonConfig,
      buttonName: buttonConfig?.action_type,
    });
    setCommentModalOpen(true);

    // updateData(postData, buttonConfig);
  };

  const updateData = (data, buttonAction) => {
    const postData = {
      jsonString: JSON.stringify([data]),
      menuId,
      pageButtonActionId: null,
      buttonAction: buttonAction?.value,
    };

    setLoading(true);
    appFetch
      .post(apiEndpoints.menuAction, {
        body: JSON.stringify(postData),
      })
      .then((result) => {
        const { ERROR_MESSAGE: errMsg, ERROR_NUMBER: errNo, layout } = result;

        const groups =
          layout.subcomponents[1].subcomponents[0].subcomponents[0].options[0]
            .groups;

        MySwal.fire({
          text: errMsg,
          icon: errNo === 0 ? "success" : "error",
        }).then(() => {
          setExpenses(groups);
        });

        if (errNo !== 0) throw new Error(errMsg);

        const emailListOptions =
          result?.layout.subcomponents?.[1]?.subcomponents?.[0]
            ?.subcomponents?.[0]?.options ?? [];
        setOptions(emailListOptions);
      })
      .catch((e) => console.error(e.message))
      .finally(() => {
        setLoading(false);
        setCommentModalOpen(false);
        setProcessing(false);
        deselectAll();
      });
  };

  return (
    <>
      {commentModalOpen && (
        <CommentModal
          buttonData={buttonData}
          setIsOpen={setCommentModalOpen}
          isOpen={commentModalOpen}
          updateData={updateData}
          processing={processing}
          setProcessing={setProcessing}
        />
      )}

      <div className="min-h-screen bg-gray-50 flex">
        <div
          className={`${
            selectedExpense && !isFullScreen ? "w-1/2" : "w-full"
          } transition-all duration-300`}
        >
          <div className="max-w-full mx-auto">
            <div className="bg-white rounded-lg shadow-sm">
              <div className="p-6">
                <div className="flex justify-end items-center mb-6 gap-2">
                  {buttons?.map((buttonConfig, idx) => (
                    <Button
                      key={idx}
                      onClick={() => handleButtonClick(buttonConfig)}
                      disabled={selectedExpenses.size === 0}
                      buttonConfig={{
                        ...buttonConfig,
                        name:
                          selectedExpenses.size > 0
                            ? `${buttonConfig.name.replace(/\sAll/i, "")} (${
                                selectedExpenses.size
                              })`
                            : buttonConfig.name,
                      }}
                    />
                  ))}
                </div>

                <div className="relative">
                  <div className="overflow-y-auto max-h-[calc(100vh-200px)] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400 scrollbar-thumb-rounded-full scrollbar-track-rounded-full">
                    <table className="min-w-full divide-y divide-gray-200">
                      {headers.length > 0 && <TableHeader headers={headers} />}
                      <tbody className="bg-white divide-y divide-gray-200">
                        {expenses?.map((expense) => (
                          <ExpenseRow
                            key={expense.Drillid}
                            expense={expense}
                            headers={headers}
                            isSelected={selectedExpenses.has(expense.Drillid)}
                            isCurrent={
                              selectedExpense?.Drillid === expense.Drillid
                            }
                            onToggle={toggleExpense}
                            onRowClick={
                              selectedExpenses.has(expense.Drillid)
                                ? () => {}
                                : handleRowClick
                            }
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="m-6 flex justify-between items-center">
              <div className="text-sm text-gray-600">
                {selectedExpenses.size} of {expenses.length} items selected
              </div>
              <div className="flex items-center gap-4">
                <div className="flex gap-2">
                  <button
                    onClick={selectAll}
                    className="text-sm text-primary hover:text-red-700 px-3 py-1 rounded border border-primary hover:bg-red-50"
                  >
                    Select All
                  </button>
                  <button
                    onClick={deselectAll}
                    className="text-sm text-gray-600 hover:text-gray-800 px-3 py-1 rounded border border-gray-300 hover:bg-gray-50"
                  >
                    Clear Selection
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {selectedExpense && (
          <DetailsPanel
            setOptions={setOptions}
            expense={selectedExpense}
            isFullScreen={isFullScreen}
            onToggleFullScreen={handleToggleFullScreen}
            onClose={handleCloseDetails}
            targetid={options[0]?.targetid}
            layoutid={options[0]?.layoutid}
            menuId={menuId}
          />
        )}
      </div>
    </>
  );
};

export default WithLoader(PendingEmailList);
